import { render, staticRenderFns } from "./collec.vue?vue&type=template&id=2cdb3504&scoped=true"
import script from "./collec.vue?vue&type=script&lang=js"
export * from "./collec.vue?vue&type=script&lang=js"
import style0 from "./collec.vue?vue&type=style&index=0&id=2cdb3504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb3504",
  null
  
)

export default component.exports